import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { IstMilestonesViewModalComponent } from './ist-milestones-view-modal/ist-milestones-view-modal.component';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { IstDataShareService } from '../../../services/ist/ist-datashare.service';
import { stateOptionsSample, DatePickerGlobalOptions } from 'src/app/constants/service.constants';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { CommonService } from '../../../services/common.service';
import { UserService } from '../../../services/user.service';
import { DatePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MileStone } from 'src/app/models/um/organization';
import { DateObject } from 'src/app/models/common';
@Component({
  selector: 'app-ist-milestones',
  templateUrl: './ist-milestones.component.html',
  styleUrls: ['./ist-milestones.component.scss']
})
export class IstMilestonesComponent implements OnInit {

  columnDefs;
  tempoperations;
  operations;
  gridApi: GridApi;
  selectedRow;
  rowData;
  advanceSearch;
  ApplicationID: string;
  milestonesform: UntypedFormGroup;
  permission: string = "";
  userType: string = "";
  StartDateO: DateObject
  EndDateO: DateObject
  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: IstSummaryService,
    private modalService: NgbModal,
    private datashareService: IstDataShareService,
    private commonService: CommonService,
    private userService: UserService,
    private datepipe: DatePipe
  ) {
  }

  ngOnInit() {
    this.permission = this.commonService.getPagePermission("IST08").toLowerCase();

    this.userType = this.userService.getUserType();
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    if (this.ApplicationID == "" || this.ApplicationID == undefined || this.ApplicationID == null) {
      const modalRef = this.modalService.open(MessageBoxComponent, {   });
      modalRef.componentInstance.Content={ heading: '', content: { heading: '', description: 'Please save General information details to navigate to Milestones', operation: { hasConfirm: false } } }
      modalRef.result.then((result) => {
        this.router.navigate(['/home/ist/my-applications/application-ext/:' + this.ApplicationID + '/general_information_request'],
          { skipLocationChange: true, queryParams: { id: this.ApplicationID, app_ext: true, module: "ist", screen_type: "my-applications" } })
      });
      return false;
    }
    this.milestonesform = new UntypedFormGroup({
      MileStone: new UntypedFormControl(""),
      Title: new UntypedFormControl(""),
      StartDate: new UntypedFormControl(null),
      EndDate: new UntypedFormControl(null),
      StartDateO : new UntypedFormControl(null),
      EndDateO:new UntypedFormControl(null)  
     

    });
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });

    if(this.userType == "E"){
      this.columnDefs = [
        {
          "headerName": "Milestone #",
          "field": "MileStone"
        },
        {
          "headerName": "Title",
          "field": "Title"
        },
        {
          "headerName": "Start Date",
          "field": "StartDateStr"
        },
        {
          "headerName": "End Date",
          "field": "EndDateStr"
        },
        {
          "headerName": "Submitted Date",
          "field": "SubmittedDateStr"
        },
        {
          "headerName": "Status",
          "field": "Status"
        }
      ];
    } else{
      this.columnDefs = [
        {
          "headerName": "Milestone #",
          "field": "MileStone"
        },
        {
          "headerName": "Title",
          "field": "Title"
        },
        {
          "headerName": "Start Date",
          "field": "StartDateStr"
        },
        {
          "headerName": "End Date",
          "field": "EndDateStr"
        },
        {
          "headerName": "Submitted Date",
          "field": "SubmittedDateStr"
        }
      ];
    }
   

    this.tempoperations = [

    ];

   
    this.advanceSearch =
    {
      "fields": [
        {
          "label": "Milestone #",
          "field": "mileStone",
          "type": "text"
        },
        {
          "label": "Title",
          "field": "title",
          "type": "text"
        },
        {
          "label": "From Date",
          "field": "startDate",
          "type": "date"
        },
        {
          "label": "To Date",
          "field": "endDate",
          "type": "date"
        }
      ]
    }

    this.operations = this.tempoperations.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });

    this.setSummary();
  }
  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }
  onAdvanceSearchOperation(searchFiletrs) {

  }

  onCallbackOperation(opr) {
    opr.callback(this.ApplicationID, this.summaryService);
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
    
    const modelRef=this['self'].modalService.open(IstMilestonesViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true
    });
    modelRef.componentInstance.Content={
      heading: 'View',
      content: { id: event.data['ID'], ApplicationID: this.ApplicationID }
    }
  }

  add(ApplicationID) {
    
    let modalRef = this['self'].modalService.open(IstMilestonesViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true
    });
      modalRef.componentInstance.Content={
      heading: 'Add',
      content: { id: "", ApplicationID: ApplicationID }
    }
    modalRef.result.then(result => {
      this['self'].setSummary();
    })
  }

  edit(ApplicationID) {
    let modalRef = this['self'].modalService.open(IstMilestonesViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true,
    });
      modalRef.componentInstance.Content={
        heading: "Edit",
        content: { id: this['self'].selectedRow['ID'], ApplicationID: ApplicationID }
      }
   
    modalRef.result.then(result => {
      this['self'].setSummary();
    })
  }

  view(ApplicationID) {
    let modalRef = this['self'].modalService.open(IstMilestonesViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true,
    });
    modalRef.componentInstance.Content={
        heading: "View",
        content: { id: this['self'].selectedRow['ID'], ApplicationID: ApplicationID }
      }
    
    modalRef.result.then(result => {
      this['self'].setSummary();
    })
  }

  delete(applicationID, summaryService, toastrService) {
    // if (this['self'].userType == "E") {
    if (this['self'].selectedRow['SubmittedDateStr'] == null || this['self'].selectedRow['SubmittedDateStr'] == undefined || this['self'].selectedRow['SubmittedDateStr'] == "") {
      let id = this['self'].selectedRow['ID'];
      let mileStone = this['self'].selectedRow['MileStone'];
      const modalRef = this["self"].modalService.open(DeleteBoxComponent, {backdrop: false});
        modalRef.componentInstance.Content= { heading: 'Delete Milestone', custommessage: 'Are you sure you want to delete the milestone  ' + mileStone + ' ?', ProceedButtonName: "Delete", TerminateButtonName: "Cancel" };

        modalRef.result.then(result => {
        if (result == "okclick") {
          summaryService.DeleteRecord('api/ISTMilestones/Delete?RecordID=' + id).subscribe(summary => {
            if (summary["Status"] == 0) {
              this["self"].commonService.SuccessBanner('Milestone ' + mileStone + ' deleted successfully');
              this['self'].setSummary();
            }
            else {
              this["self"].commonService.ValidationBanner("Selected Record(s) has not been Deleted");

            }
          });
        }
      });
    }
    else {
      this.commonService.ValidationBanner("Record Can't be Deleted");
      // this['self'].modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: "Record Can't be Deleted." } } });
    }
    // }
    // else {
    //   this['self'].modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: "Record Can't be Deleted.." } } });
    // }
  }

  setSummary() {
    //
    this.SearchClear();
    this.summaryService.getSummaryData("api/ISTMilestones/getSummaryData?ApplicationID=" + this.ApplicationID).subscribe(summary => {
      this.rowData = this.setOperations(summary);
    });
  }

  getSearchSummary(searchObject) {
    this.summaryService.fetchSearchData("api/ISTMilestones/getSummarySearchData", searchObject).subscribe(summary => {
      this.rowData = this.setOperations(summary);
    });
  }

  SearchClear() {
    // this.milestonesform.reset();

    this.milestonesform.controls["MileStone"].setValue("");
    this.milestonesform.controls["Title"].setValue("");
    this.milestonesform.controls["StartDate"].setValue(null);
    this.milestonesform.controls["EndDate"].setValue(null);
    //  this.setSummary();
  }
 
  // GetStartDate(): DateObject {
  //   //let lDate = this.milestoneForm.controls['STUDY_START_DATE'].value;

  //   //let lDate = new Date(this.milestoneForm['STUDY_START_DATE'])
  //   if (  this.Full_Start_Date == null || this.Full_Start_Date == undefined) {
  //     this.Full_Start_Date = {
  //       Day: lDate.getDay(),
  //       Month: lDate.getMonth() + 1,
  //       Year: lDate.getFullYear(),
  //       Hours: 0,
  //       Minutes: 0,
  //       Seconds: 0,
  //       IsEndDate: false,
  //       HasValue: true,
  //       IsDateModified: true
  //     }
  //   }
  //   return this.Full_Start_Date
  // }
  isStartDateModified: boolean = false;
  isEndDateModified: boolean = false;
  Full_Start_Date: DateObject;
  Full_End_Date: DateObject;

  startDateSelect(event) {
    this.isStartDateModified = true
    this.Full_Start_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isStartDateModified
    }
  }
  endDateSelect(event) {
    this.isEndDateModified = true;
    this.Full_End_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: true,
      HasValue: true,
      IsDateModified: this.isEndDateModified
    }
  }

  AdvanceSearch() {
    var formData = this.milestonesform.value;
    if(!this.validateSearch()){
      
      formData["ApplicationID"] = this.ApplicationID;
      if (formData["StartDate"] != null && formData["StartDate"] != undefined && formData["StartDate"] != 'Invalid Date') {
        formData["StartDate"] = new Date(formData["StartDate"]);
        formData["StartDateO"] = this.Full_Start_Date;
      }
      if (formData["EndDate"] != null && formData["EndDate"] != undefined && formData["EndDate"] != 'Invalid Date') {
        formData["EndDate"] = new Date(formData["EndDate"]);
        formData["EndDateO"] = this.Full_End_Date;
      }
      if (formData["StartDate"] != null && formData["StartDate"] != "" && formData["StartDate"] != undefined && formData["StartDate"] != 'Invalid Date') {
        formData["StartDateStr"] = this.datepipe.transform(formData["StartDate"], 'dd-MMM-yyyy');
      }
      if (formData["EndDate"] != null && formData["EndDate"] != "" && formData["EndDate"] != undefined && formData["EndDate"] != 'Invalid Date') {
        formData["EndDateStr"] = this.datepipe.transform(formData["EndDate"], 'dd-MMM-yyyy');
      }
      formData["StartDate"] = null;
      formData["EndDate"] = null;
      this.getSearchSummary(formData);
    } else{
      this.commonService.ValidationBanner("Please enter at least one criteria to perform search");
      // this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: "Please enter at least one criteria to perform search" } } });

    }   
  }

  validateSearch(){
    let hasValue : Boolean = true;
    if(this.milestonesform.controls["EndDate"].value != null && this.milestonesform.controls["EndDate"].value != undefined && this.milestonesform.controls["EndDate"].value != 'Invalid Date'){
      hasValue = false;
    }

    if (this.milestonesform.controls["StartDate"].value != null && this.milestonesform.controls["StartDate"].value != undefined && this.milestonesform.controls["StartDate"].value != 'Invalid Date') {
      hasValue = false;
    }

    if (this.milestonesform.controls["MileStone"].value != null && this.milestonesform.controls["MileStone"].value != undefined && this.milestonesform.controls["MileStone"].value != "") {
      hasValue = false;
    }

    if (this.milestonesform.controls["Title"].value != null && this.milestonesform.controls["Title"].value != undefined && this.milestonesform.controls["Title"].value != "") {
      hasValue = false;
    }
    return hasValue;
  }

  setOperations(RawData: any): any {

    if (this.permission == "new") {
      this.tempoperations = [
        {
          "name": "Edit",
          "id": "edit"
        },
        {
          "name": "Delete",
          "id": "delete"
        },
        {
          "name": "View",
          "id": "view"
        },
        {
          "name": "Add New Milestone",
          "id": "add"
        }
      ];
    }

    if (this.permission == "edit") {
      this.tempoperations = [
        {
          "name": "Edit",
          "id": "edit"
        },
        {
          "name": "Delete",
          "id": "delete"
        },
        {
          "name": "View",
          "id": "view"
        }
      ];
    }    

    this.setDef(this.tempoperations);
    RawData.forEach(element => {
      if (element.Status == "Submitted") {
        let tempoperations2 = [
          {
            "name": "View",
            "id": "view"
          }
        ];
        if (this.permission == "new") {
          tempoperations2.push({
            "name": "Add New Milestone",
            "id": "add"
          })
        }
        element["Operations"] = this.setDef(tempoperations2);
      }

      if (element.Status == "Drafted") {
        element["Operations"] = this.setDef(this.tempoperations);
      }

      if (this.permission == "view") {
        this.tempoperations = [          
          {
            "name": "View",
            "id": "view"
          }
        ];

        element["Operations"] = this.setDef(this.tempoperations);
      }    
    });
    return RawData;
  }

  setDef(parmoperations: any): any {
    //this.tempoperations = parmoperations;
    this.operations = parmoperations.map(operation => {
      return operation &&
        (operation.id === "add" || operation.id === "view_modal")
        ? {
          name: operation.name,
          callback: this[operation.id],
          self: this,
          disabled: "false"
        }
        : { name: operation.name, callback: this[operation.id], self: this };
    });
    return this.operations;
  }




}
